@if (shouldShowAlert) {
  <cdk-accordion-item #accordionItem="cdkAccordionItem" role="button" [expanded]="isExpanded">
    <div
      class="flex cursor-pointer items-center overflow-hidden rounded-[32px] border drop-shadow-alert backdrop-blur-2xl"
      [ngClass]="{
        'border-alert-border-red bg-alert-background-red': isMedicalAlert,
        'border-alert-border-yellow bg-alert-background-yellow': isPatientAlert
      }"
    >
      <div class="m-6 mx-6 my-3 flex w-full flex-col">
        <!-- Title -->
        <div class="flex items-center gap-1" (click)="onToggleExpanded()">
          <svg-icon size="sm" [key]="iconKey" [class]="iconColor"></svg-icon>
          {{ (isMedicalAlert ? 'patient_alerts_medical_alert_title' : 'patient_alerts_patient_alert_title') | translate }}

          <svg-icon
            class="ml-auto text-text-black transition-transform"
            [ngClass]="{
              'rotate-[180deg]': accordionItem.expanded
            }"
            key="px-24-arrow-down"
          ></svg-icon>
        </div>

        <div [@slideToggle]="accordionItem.expanded ? 'expanded' : 'collapsed'" class="flex w-full flex-col gap-4 overflow-hidden">
          <div></div>
          <!-- Medical Alert Content -->
          @if (isMedicalAlert) {
            <div class="typo-h5-semibold text-text-primary">
              {{ medicalAlert.alerts.join(', ') }}
            </div>
          }
          <!-- Patient Alert Content -->
          @if (isPatientAlert) {
            <div class="flex flex-col gap-2">
              <div>
                <p class="typo-h5-semibold max-w-[334px] truncate text-text-primary">{{ patientAlert.description }}</p>
              </div>
              <div>
                <p class="typo-h5-book line-clamp-5 max-w-[334px] break-all text-text-secondary">{{ patientAlert.notes }}</p>
              </div>
            </div>
          }
          <!-- Buttons -->
          <ffd-alert-action-buttons
            [alert]="alert"
            (hideAlert)="onHideAlert()"
            (openHealthHistory)="onOpenHealthHistory()"
          ></ffd-alert-action-buttons>
        </div>
      </div></div
  ></cdk-accordion-item>
}
